/* eslint-disable */

/* global GFSquareBlockStrings */
/**
 * @module
 * @exports ready
 * @description The core dispatcher for the dom ready event in javascript.
 *
 */

import { ready } from '../../common/utils';
import a11yErrorHandler from '../square/a11y-error-handler';
import WebPayments from '../../common/square/web-payments';
import CardRenderer from '../../common/square/card-renderer';
import cardStyles from '../../common/square/card-styles';
import helpers from '../../common/square/helpers';
import jQuery from 'jquery';
/**
 * @function bindEvents
 * @description Bind global event listeners here,
 *
 */
let cardRenderer = {};

/**
 * @function init
 * @description The core dispatcher for init across the codebase.
 *
 */

const init = () => {
	jQuery( document ).ready( () => {
		const getBlockList = () => wp.data.select( 'core/block-editor' ).getBlocks();
		let blockList = getBlockList();
		wp.data.subscribe( () => {
			const newBlockList = getBlockList();
			const blockListChanged = newBlockList !== blockList;
			blockList = newBlockList;
			if ( blockListChanged ) {
				setTimeout( renderBlockCard, 2000 );
			}
		} );

		renderBlockCard();
	} );
};

const renderBlockCard = () => {
	gform.extensions = gform.extensions || {};
	gform.extensions.styles = gform.extensions.styles || {};
	gform.extensions.styles.gravityformssquare = gform.extensions.styles.gravityformssquare || {};

	const webPayments = new WebPayments( gforms_square_theme_strings.gformSquareBlockStrings.formId, gforms_square_theme_strings.gformSquareBlockStrings.applicationId, gforms_square_theme_strings.gformSquareBlockStrings.locationId );
	const styleObject = cardStyles( gforms_square_theme_strings.gformSquareBlockStrings.formId, gforms_square_theme_strings.gformSquareBlockStrings.pageInstance );
	if ( 'card' in cardRenderer && cardRenderer.card !== null ) {
		cardRenderer.card.destroy();
	}
	cardRenderer = new CardRenderer( webPayments, null, gforms_square_theme_strings.gformSquareBlockStrings.formId, gforms_square_theme_strings.gformSquareBlockStrings.pageInstance, gforms_square_theme_strings.gformSquareBlockStrings.ccFieldId, styleObject, 'block', gforms_square_theme_strings.gformSquareBlockStrings );

	helpers.formId = gforms_square_theme_strings.gformSquareBlockStrings.formId;

	console.info(
		'Gravity Forms Square: Initialized all Block Editor that targeted document ready.'
	);
};

/**
 * @function domReady
 * @description Export our dom ready enabled init.
 *
 */

const domReady = () => {
	ready( init );
};

export default domReady;
